import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enMain from './locales/en/main.json';
import enPricingBanner from './locales/en/pricing-banner.json';
import enHeader from './locales/en/header.json';
import enFeatures from './locales/en/features.json';
import enPricing from './locales/en/pricing.json';
import enAbout from './locales/en/about.json';
import enFooter from './locales/en/footer.json';
import enTextToSlides from './locales/en/text-to-slides.json';
import enPaymentsDialog from './locales/en/payments-dialog.json';
import enTextToSlidesPreview from './locales/en/text-to-slides-preview.json';
import enCommon from './locales/en/common.json';
import enSetupStyle from './locales/en/setup-style.json';
import enFinalizeStage from './locales/en/finalize-stage.json';
import enAuth from './locales/en/auth.json';
import enProjects from './locales/en/projects.json';
import enTrialPopup from './locales/en/trial-popup.json';
import enImageGeneration from './locales/en/image-generation.json';
import enLegal from './locales/en/legal.json';
import enCookiePopup from './locales/en/cookie-popup.json';
import ruMain from './locales/ru/main.json';
import ruPricingBanner from './locales/ru/pricing-banner.json';
import ruHeader from './locales/ru/header.json';
import ruFeatures from './locales/ru/features.json';
import ruPricing from './locales/ru/pricing.json';
import ruAbout from './locales/ru/about.json';
import ruFooter from './locales/ru/footer.json';
import ruTextToSlides from './locales/ru/text-to-slides.json';
import ruPaymentsDialog from './locales/ru/payments-dialog.json';
import ruTextToSlidesPreview from './locales/ru/text-to-slides-preview.json';
import ruCommon from './locales/ru/common.json';
import ruSetupStyle from './locales/ru/setup-style.json';
import ruFinalizeStage from './locales/ru/finalize-stage.json';
import ruAuth from './locales/ru/auth.json';
import ruProjects from './locales/ru/projects.json';
import ruTrialPopup from './locales/ru/trial-popup.json';
import ruImageGeneration from './locales/ru/image-generation.json';
import ruLegal from './locales/ru/legal.json';
import ruCookiePopup from './locales/ru/cookie-popup.json';
import esMain from './locales/es/main.json';
import esPricingBanner from './locales/es/pricing-banner.json';
import esHeader from './locales/es/header.json';
import esFeatures from './locales/es/features.json';
import esPricing from './locales/es/pricing.json';
import esAbout from './locales/es/about.json';
import esFooter from './locales/es/footer.json';
import esTextToSlides from './locales/es/text-to-slides.json';
import esPaymentsDialog from './locales/es/payments-dialog.json';
import esTextToSlidesPreview from './locales/es/text-to-slides-preview.json';
import esCommon from './locales/es/common.json';
import esSetupStyle from './locales/es/setup-style.json';
import esFinalizeStage from './locales/es/finalize-stage.json';
import esAuth from './locales/es/auth.json';
import esProjects from './locales/es/projects.json';
import esTrialPopup from './locales/es/trial-popup.json';
import esImageGeneration from './locales/es/image-generation.json';
import esLegal from './locales/es/legal.json';
import esCookiePopup from './locales/es/cookie-popup.json';
import frMain from './locales/fr/main.json';
import frPricingBanner from './locales/fr/pricing-banner.json';
import frHeader from './locales/fr/header.json';
import frFeatures from './locales/fr/features.json';
import frPricing from './locales/fr/pricing.json';
import frAbout from './locales/fr/about.json';
import frFooter from './locales/fr/footer.json';
import frTextToSlides from './locales/fr/text-to-slides.json';
import frPaymentsDialog from './locales/fr/payments-dialog.json';
import frTextToSlidesPreview from './locales/fr/text-to-slides-preview.json';
import frCommon from './locales/fr/common.json';
import frSetupStyle from './locales/fr/setup-style.json';
import frFinalizeStage from './locales/fr/finalize-stage.json';
import frAuth from './locales/fr/auth.json';
import frProjects from './locales/fr/projects.json';
import frTrialPopup from './locales/fr/trial-popup.json';
import frImageGeneration from './locales/fr/image-generation.json';
import frLegal from './locales/fr/legal.json';
import frCookiePopup from './locales/fr/cookie-popup.json';
import deMain from './locales/de/main.json';
import dePricingBanner from './locales/de/pricing-banner.json';
import deHeader from './locales/de/header.json';
import deFeatures from './locales/de/features.json';
import dePricing from './locales/de/pricing.json';
import deAbout from './locales/de/about.json';
import deFooter from './locales/de/footer.json';
import deTextToSlides from './locales/de/text-to-slides.json';
import dePaymentsDialog from './locales/de/payments-dialog.json';
import deTextToSlidesPreview from './locales/de/text-to-slides-preview.json';
import deCommon from './locales/de/common.json';
import deSetupStyle from './locales/de/setup-style.json';
import deFinalizeStage from './locales/de/finalize-stage.json';
import deAuth from './locales/de/auth.json';
import deProjects from './locales/de/projects.json';
import deTrialPopup from './locales/de/trial-popup.json';
import deImageGeneration from './locales/de/image-generation.json';
import deLegal from './locales/de/legal.json';
import deCookiePopup from './locales/de/cookie-popup.json';
import ptBRMain from './locales/pt-BR/main.json';
import ptBRPricingBanner from './locales/pt-BR/pricing-banner.json';
import ptBRHeader from './locales/pt-BR/header.json';
import ptBRFeatures from './locales/pt-BR/features.json';
import ptBRPricing from './locales/pt-BR/pricing.json';
import ptBRAbout from './locales/pt-BR/about.json';
import ptBRFooter from './locales/pt-BR/footer.json';
import ptBRTextToSlides from './locales/pt-BR/text-to-slides.json';
import ptBRPaymentsDialog from './locales/pt-BR/payments-dialog.json';
import ptBRTextToSlidesPreview from './locales/pt-BR/text-to-slides-preview.json';
import ptBRCommon from './locales/pt-BR/common.json';
import ptBRSetupStyle from './locales/pt-BR/setup-style.json';
import ptBRFinalizeStage from './locales/pt-BR/finalize-stage.json';
import ptBRAuth from './locales/pt-BR/auth.json';
import ptBRProjects from './locales/pt-BR/projects.json';
import ptBRTrialPopup from './locales/pt-BR/trial-popup.json';
import ptBRImageGeneration from './locales/pt-BR/image-generation.json';
import ptBRLegal from './locales/pt-BR/legal.json';
import ptBRCookiePopup from './locales/pt-BR/cookie-popup.json';

import { detectBrowserLanguage } from './utils/detect-browser-language';
import { extractLanguageFromPath } from './utils/language-url';
import {
  getLanguageFromCookie,
  setLanguageCookie,
  setProgrammaticCookieFlag,
} from './utils/language-cookie';
import { SUPPORTED_LANGUAGES } from './constants';

// Получаем язык с приоритетом: кука (от бэкенда или фронтенда) > URL > браузер
// Всегда возвращает поддерживаемый язык или 'en' по умолчанию
const getInitialLanguage = (): string => {
  const supportedCodes = SUPPORTED_LANGUAGES.map((lang) => lang.code);

  // Приоритет 1: Кука 'lang' (может быть установлена бэкендом или фронтендом)
  // Бэкенд устанавливает эту куку на основе своих приоритетов
  const cookieLang = getLanguageFromCookie();
  if (cookieLang && supportedCodes.includes(cookieLang)) {
    // Кука уже установлена (бэкендом или ранее фронтендом) - используем её
    return cookieLang;
  }

  // Приоритет 2: Язык из URL
  // Бекенд уже обработал URL и установил язык, но фронтенд должен синхронизироваться
  if (typeof window !== 'undefined') {
    const urlLang = extractLanguageFromPath(window.location.pathname);
    if (urlLang && supportedCodes.includes(urlLang)) {
      // Сохраняем язык из URL в куку для следующего визита
      setProgrammaticCookieFlag(true);
      setLanguageCookie(urlLang, true);
      setProgrammaticCookieFlag(false);
      return urlLang;
    }
  }

  // Приоритет 3: Язык браузера (fallback)
  // Если нет ни куки, ни URL префикса, определяем язык браузера
  const browserLang = detectBrowserLanguage();

  // Проверяем, что язык браузера поддерживается (защита от дурака)
  if (browserLang && supportedCodes.includes(browserLang)) {
    // Сохраняем определенный язык в куку
    setProgrammaticCookieFlag(true);
    setLanguageCookie(browserLang, true);
    setProgrammaticCookieFlag(false);
    return browserLang;
  }

  // Fallback: английский по умолчанию
  // Если язык не найден или не поддерживается, возвращаем 'en'
  setProgrammaticCookieFlag(true);
  setLanguageCookie('en', true);
  setProgrammaticCookieFlag(false);
  return 'en';
};

i18n.use(initReactI18next).init({
  resources: {
    en: {
      main: enMain,
      'pricing-banner': enPricingBanner,
      header: enHeader,
      features: enFeatures,
      pricing: enPricing,
      about: enAbout,
      footer: enFooter,
      'text-to-slides': enTextToSlides,
      'payments-dialog': enPaymentsDialog,
      'text-to-slides-preview': enTextToSlidesPreview,
      common: enCommon,
      'setup-style': enSetupStyle,
      'finalize-stage': enFinalizeStage,
      auth: enAuth,
      projects: enProjects,
      'trial-popup': enTrialPopup,
      'image-generation': enImageGeneration,
      legal: enLegal,
      'cookie-popup': enCookiePopup,
    },
    ru: {
      main: ruMain,
      'pricing-banner': ruPricingBanner,
      header: ruHeader,
      features: ruFeatures,
      pricing: ruPricing,
      about: ruAbout,
      footer: ruFooter,
      'text-to-slides': ruTextToSlides,
      'payments-dialog': ruPaymentsDialog,
      'text-to-slides-preview': ruTextToSlidesPreview,
      common: ruCommon,
      'setup-style': ruSetupStyle,
      'finalize-stage': ruFinalizeStage,
      auth: ruAuth,
      projects: ruProjects,
      'trial-popup': ruTrialPopup,
      'image-generation': ruImageGeneration,
      legal: ruLegal,
      'cookie-popup': ruCookiePopup,
    },
    es: {
      main: esMain,
      'pricing-banner': esPricingBanner,
      header: esHeader,
      features: esFeatures,
      pricing: esPricing,
      about: esAbout,
      footer: esFooter,
      'text-to-slides': esTextToSlides,
      'payments-dialog': esPaymentsDialog,
      'text-to-slides-preview': esTextToSlidesPreview,
      common: esCommon,
      'setup-style': esSetupStyle,
      'finalize-stage': esFinalizeStage,
      auth: esAuth,
      projects: esProjects,
      'trial-popup': esTrialPopup,
      'image-generation': esImageGeneration,
      legal: esLegal,
      'cookie-popup': esCookiePopup,
    },
    fr: {
      main: frMain,
      'pricing-banner': frPricingBanner,
      header: frHeader,
      features: frFeatures,
      pricing: frPricing,
      about: frAbout,
      footer: frFooter,
      'text-to-slides': frTextToSlides,
      'payments-dialog': frPaymentsDialog,
      'text-to-slides-preview': frTextToSlidesPreview,
      common: frCommon,
      'setup-style': frSetupStyle,
      'finalize-stage': frFinalizeStage,
      auth: frAuth,
      projects: frProjects,
      'trial-popup': frTrialPopup,
      'image-generation': frImageGeneration,
      legal: frLegal,
      'cookie-popup': frCookiePopup,
    },
    de: {
      main: deMain,
      'pricing-banner': dePricingBanner,
      header: deHeader,
      features: deFeatures,
      pricing: dePricing,
      about: deAbout,
      footer: deFooter,
      'text-to-slides': deTextToSlides,
      'payments-dialog': dePaymentsDialog,
      'text-to-slides-preview': deTextToSlidesPreview,
      common: deCommon,
      'setup-style': deSetupStyle,
      'finalize-stage': deFinalizeStage,
      auth: deAuth,
      projects: deProjects,
      'trial-popup': deTrialPopup,
      'image-generation': deImageGeneration,
      legal: deLegal,
      'cookie-popup': deCookiePopup,
    },
    'pt-BR': {
      main: ptBRMain,
      'pricing-banner': ptBRPricingBanner,
      header: ptBRHeader,
      features: ptBRFeatures,
      pricing: ptBRPricing,
      about: ptBRAbout,
      footer: ptBRFooter,
      'text-to-slides': ptBRTextToSlides,
      'payments-dialog': ptBRPaymentsDialog,
      'text-to-slides-preview': ptBRTextToSlidesPreview,
      common: ptBRCommon,
      'setup-style': ptBRSetupStyle,
      'finalize-stage': ptBRFinalizeStage,
      auth: ptBRAuth,
      projects: ptBRProjects,
      'trial-popup': ptBRTrialPopup,
      'image-generation': ptBRImageGeneration,
      legal: ptBRLegal,
      'cookie-popup': ptBRCookiePopup,
    },
  },
  lng: getInitialLanguage(),
  fallbackLng: 'en',
  defaultNS: 'main',
  interpolation: {
    escapeValue: false,
  },
});

// Сохраняем язык при его изменении в куку
// Используем флаг для предотвращения циклических обновлений
i18n.on('languageChanged', (lng) => {
  // Проверяем текущую куку - если она уже установлена с нужным значением, не обновляем
  const currentLang = getLanguageFromCookie();
  if (currentLang === lng) {
    // Кука уже установлена с нужным значением, не обновляем (избегаем циклических обновлений)
    return;
  }
  // Устанавливаем куку программно (с флагом для предотвращения лишних проверок)
  setProgrammaticCookieFlag(true);
  setLanguageCookie(lng, true);
  setProgrammaticCookieFlag(false);
});

export default i18n;
